import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {EditUserComponent} from './edit-user/edit-user.component';
import {EditCompanyComponent} from './edit-company/edit-company.component';
import {ProfileComponent} from './profile.component';

/**
 * @class ProfileRoutingModule
 * @memberOf ProfileModule
 * @description This is a module which include all the components that belongs to profile
 */
const routes: Routes = [
  {
    path: '',
    component: ProfileComponent
  },
  {
    path: 'edit-user',
    component: EditUserComponent,
  },
  {
    path: 'edit-company',
    component: EditCompanyComponent,
  },
];



@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProfileRoutingModule {
}
